import AppInfo from "./version.json"

const env = AppInfo.env
let __CONFIG__ = {}
let country = "US"
let liveAgentDeploymentScript = 'https://c.la4-c1-was.salesforceliveagent.com/content/g/js/43.0/deployment.js'
let liveAgentPreChatScript = 'https://c.la4-c1-was.salesforceliveagent.com/content/g/js/43.0/prechat.js'
let liveAgentInitURL = 'https://d.la4-c1-was.salesforceliveagent.com/chat'
let liveAgentChatId = '57236000000fxX7'
let liveAgentOrgId = '00D36000000JRDj'
let liveAgentButtonId = '57336000000fxX2'
let liveAgentImage = 'https://newtopia.secure.force.com/Dashboard/resource/1538149178000/liveAgent_chat'

const api_path = "/services/apexrest/"
const router = "router/rapi/"

let lambda_base
switch(env) {
  case 'sfadm':
    const dev_base_public = "newtopia--sfadm.sandbox.my.salesforce-sites.com"
    const dev_base = "newtopia--sfadm.my.salesforce.com"
    lambda_base = "https://lambda-sfroute.ntp-dev.com/"
    const sfroute_base_url_dev_public = `${lambda_base}sfroute?url=${dev_base_public}&path=${api_path}`
    const sfroute_base_url_dev = `${lambda_base}sfroute?url=${dev_base}&path=${api_path}${router}`

    __CONFIG__ = {
      env,
      country,
      liveAgentDeploymentScript,
      liveAgentPreChatScript,
      liveAgentInitURL,
      liveAgentChatId,
      liveAgentOrgId,
      liveAgentButtonId,
      liveAgentImage,
      endpoint_get_liveagent: `${sfroute_base_url_dev_public}v1/getLiveAgent&public=true`,
      endpoint_get_stepcompleted: `${sfroute_base_url_dev}v3/getStepCompleted`,
      endpoint_get_landing_configuration: `${sfroute_base_url_dev_public}v1/getLandingConfiguration&public=true`,
      endpoint_upsert_qna: `${sfroute_base_url_dev}v3/upsertQnA`,
      endpoint_get_qna: `${sfroute_base_url_dev}v3/getQnA`,
      endpoint_verify_unique_email: `${sfroute_base_url_dev}v2/verifyUniqueEmail`,
      endpoint_process_questionnaire: `${sfroute_base_url_dev}v3/processQuestionnaire`,
      endpoint_get_registration_configuration: `${sfroute_base_url_dev_public}v5/getRegistrationConfiguration&public=true`,
      endpoint_process_registration: `${sfroute_base_url_dev}v8/processRegistration`,
      endpoint_authenticate_participant_lead: `${sfroute_base_url_dev_public}v6/authenticateParticipantLead&public=true`,
      endpoint_get_screener_configuration: `${sfroute_base_url_dev}v2/getScreenerConfiguration`,
      endpoint_process_profile: `${sfroute_base_url_dev}v4/processProfile`,
      endpoint_process_welcome: `${sfroute_base_url_dev}v2/processWelcome`,
      endpoint_process_genetic: `${sfroute_base_url_dev}v2/processGenetic`,
      endpoint_getInspiratorTimes: `${sfroute_base_url_dev}v2/getInspiratorSessions`,
      endpoint_createEvent: `${sfroute_base_url_dev}v2/createEventPlId`,
      endpoint_updateStepCompleted: `${sfroute_base_url_dev}v2/updateStepCompleted`,
      endpoint_findSessions: `${sfroute_base_url_dev}v2/findInspiratorSessions`,
      endpoint_getEvents: `${sfroute_base_url_dev}v2/getEvents`,
      endpoint_getEvents_public: `${sfroute_base_url_dev_public}v1/getEvents&public=true`,
      endpoint_assignInspirator: `${sfroute_base_url_dev}v2/assignInspirator`,
      endpoint_getInspiratorInfo: `${sfroute_base_url_dev}v2/getInspirator`,
      endpoint_isJPMCPilot: `${sfroute_base_url_dev}v1/isJPMCPilot`,
      endpoint_getClientData: `${sfroute_base_url_dev_public}v4/getClientData&public=true`,
      endpoint_collectEmail: `${sfroute_base_url_dev}v1/collectEmail`,
    }
    break

  case 'sfadm_ca':
    const ca_dev_base_public = "newtopia--sfadm.sandbox.my.salesforce-sites.com"
    const ca_dev_base = "newtopia--sfadm.my.salesforce.com"
    lambda_base = "https://lambda-sfroute.ntp-dev.com/"
    const ca_sfroute_base_url_dev_public = `${lambda_base}sfroute?url=${ca_dev_base_public}&path=${api_path}`
    const ca_sfroute_base_url_dev = `${lambda_base}sfroute?url=${ca_dev_base}&path=${api_path}${router}`
    country = "CA"
    liveAgentDeploymentScript = 'https://c.la1-c1-yul.salesforceliveagent.com/content/g/js/51.0/deployment.js'
    liveAgentPreChatScript = 'https://c.la1-c1-yul.salesforceliveagent.com/content/g/js/51.0/prechat.js'
    liveAgentInitURL = 'https://d.la1-c1-yul.salesforceliveagent.com/chat'
    liveAgentChatId = '5725o00000001Uw'
    liveAgentOrgId = '00D5o0000008an9'
    liveAgentButtonId = '5735o00000001V6'
    liveAgentImage = 'https://newtopiaca.secure.force.com/Dashboard/resource/1606966297000/liveAgent_chat'

    __CONFIG__ = {
      env,
      country,
      liveAgentDeploymentScript,
      liveAgentPreChatScript,
      liveAgentInitURL,
      liveAgentChatId,
      liveAgentOrgId,
      liveAgentButtonId,
      liveAgentImage,
      endpoint_get_liveagent: `${ca_sfroute_base_url_dev_public}v1/getLiveAgent&public=true`,
      endpoint_get_stepcompleted: `${ca_sfroute_base_url_dev}v3/getStepCompleted`,
      endpoint_get_landing_configuration: `${ca_sfroute_base_url_dev_public}v1/getLandingConfiguration&public=true`,
      endpoint_upsert_qna: `${ca_sfroute_base_url_dev}v3/upsertQnA`,
      endpoint_get_qna: `${ca_sfroute_base_url_dev}v3/getQnA`,
      endpoint_verify_unique_email: `${ca_sfroute_base_url_dev}v2/verifyUniqueEmail`,
      endpoint_process_questionnaire: `${ca_sfroute_base_url_dev}v3/processQuestionnaire`,
      endpoint_get_registration_configuration: `${ca_sfroute_base_url_dev_public}v5/getRegistrationConfiguration&public=true`,
      endpoint_process_registration: `${ca_sfroute_base_url_dev}v8/processRegistration`,
      endpoint_authenticate_participant_lead: `${ca_sfroute_base_url_dev_public}v6/authenticateParticipantLead&public=true`,
      endpoint_get_screener_configuration: `${ca_sfroute_base_url_dev}v2/getScreenerConfiguration`,
      endpoint_process_profile: `${ca_sfroute_base_url_dev}v4/processProfile`,
      endpoint_process_welcome: `${ca_sfroute_base_url_dev}v2/processWelcome`,
      endpoint_process_genetic: `${ca_sfroute_base_url_dev}v2/processGenetic`,
      endpoint_getInspiratorTimes: `${ca_sfroute_base_url_dev}v2/getInspiratorSessions`,
      endpoint_createEvent: `${ca_sfroute_base_url_dev}v2/createEventPlId`,
      endpoint_updateStepCompleted: `${ca_sfroute_base_url_dev}v2/updateStepCompleted`,
      endpoint_findSessions: `${ca_sfroute_base_url_dev}v2/findInspiratorSessions`,
      endpoint_getEvents: `${ca_sfroute_base_url_dev}v2/getEvents`,
      endpoint_getEvents_public: `${ca_sfroute_base_url_dev_public}v1/getEvents&public=true`,
      endpoint_assignInspirator: `${ca_sfroute_base_url_dev}v2/assignInspirator`,
      endpoint_getInspiratorInfo: `${ca_sfroute_base_url_dev}v2/getInspirator`,
      endpoint_isJPMCPilot: `${ca_sfroute_base_url_dev}v1/isJPMCPilot`,
      endpoint_getClientData: `${ca_sfroute_base_url_dev_public}v4/getClientData&public=true`,
      endpoint_collectEmail: `${ca_sfroute_base_url_dev}v1/collectEmail`,
    }
    break

  case 'sfqa':
    const qa_base_public = "sfqa-newtopia.cs23.force.com"
    const qa_base = "newtopia--sfqa.my.salesforce.com"
    lambda_base = "https://lambda-sfroute.ntp-dev.com/"
    const sfroute_base_url_qa_public = `${lambda_base}sfroute?url=${qa_base_public}&path=${api_path}`
    const sfroute_base_url_qa = `${lambda_base}sfroute?url=${qa_base}&path=${api_path}${router}`

    __CONFIG__ = {
      env,
      country,
      liveAgentDeploymentScript,
      liveAgentPreChatScript,
      liveAgentInitURL,
      liveAgentChatId,
      liveAgentOrgId,
      liveAgentButtonId,
      liveAgentImage,
      endpoint_get_liveagent: `${sfroute_base_url_qa_public}v1/getLiveAgent&public=true`,
      endpoint_get_stepcompleted: `${sfroute_base_url_qa}v3/getStepCompleted`,
      endpoint_get_landing_configuration: `${sfroute_base_url_qa_public}v1/getLandingConfiguration&public=true`,
      endpoint_upsert_qna: `${sfroute_base_url_qa}v3/upsertQnA`,
      endpoint_get_qna: `${sfroute_base_url_qa}v3/getQnA`,
      endpoint_verify_unique_email: `${sfroute_base_url_qa}v2/verifyUniqueEmail`,
      endpoint_process_questionnaire: `${sfroute_base_url_qa}v3/processQuestionnaire`,
      endpoint_get_registration_configuration: `${sfroute_base_url_qa_public}v5/getRegistrationConfiguration&public=true`,
      endpoint_process_registration: `${sfroute_base_url_qa}v8/processRegistration`,
      endpoint_authenticate_participant_lead: `${sfroute_base_url_qa_public}v6/authenticateParticipantLead&public=true`,
      endpoint_get_screener_configuration: `${sfroute_base_url_qa}v2/getScreenerConfiguration`,
      endpoint_process_profile: `${sfroute_base_url_qa}v4/processProfile`,
      endpoint_process_welcome: `${sfroute_base_url_qa}v2/processWelcome`,
      endpoint_process_genetic: `${sfroute_base_url_qa}v2/processGenetic`,
      endpoint_getInspiratorTimes: `${sfroute_base_url_qa}v2/getInspiratorSessions`,
      endpoint_createEvent: `${sfroute_base_url_qa}v2/createEventPlId`,
      endpoint_updateStepCompleted: `${sfroute_base_url_qa}v2/updateStepCompleted`,
      endpoint_findSessions: `${sfroute_base_url_qa}v2/findInspiratorSessions`,
      endpoint_getEvents: `${sfroute_base_url_qa}v2/getEvents`,
      endpoint_getEvents_public: `${sfroute_base_url_qa_public}v1/getEvents&public=true`,
      endpoint_assignInspirator: `${sfroute_base_url_qa}v2/assignInspirator`,
      endpoint_getInspiratorInfo: `${sfroute_base_url_qa}v2/getInspirator`,
      endpoint_isJPMCPilot: `${sfroute_base_url_qa}v1/isJPMCPilot`,
      endpoint_getClientData: `${sfroute_base_url_qa_public}v4/getClientData&public=true`,
      endpoint_collectEmail: `${sfroute_base_url_qa}v1/collectEmail`,
    }
    break
  case "sfrc":
    const rc_base_public = "newtopia--rc.sandbox.my.salesforce-sites.com"
    const rc_base = "newtopia--rc.my.salesforce.com"
    lambda_base = "https://release-api-sfroute.ntp-dev.com/"
    const sfroute_base_url_rc_public = `${lambda_base}sfroute?url=${rc_base_public}&path=${api_path}`
    const sfroute_base_url_rc = `${lambda_base}sfroute?url=${rc_base}&path=${api_path}${router}`

    __CONFIG__ = {
      env,
      country,
      liveAgentDeploymentScript,
      liveAgentPreChatScript,
      liveAgentInitURL,
      liveAgentChatId,
      liveAgentOrgId,
      liveAgentButtonId,
      liveAgentImage,
      endpoint_get_liveagent: `${sfroute_base_url_rc_public}v1/getLiveAgent&public=true`,
      endpoint_get_stepcompleted: `${sfroute_base_url_rc}v3/getStepCompleted`,
      endpoint_get_landing_configuration: `${sfroute_base_url_rc_public}v1/getLandingConfiguration&public=true`,
      endpoint_upsert_qna: `${sfroute_base_url_rc}v3/upsertQnA`,
      endpoint_get_qna: `${sfroute_base_url_rc}v3/getQnA`,
      endpoint_verify_unique_email: `${sfroute_base_url_rc}v2/verifyUniqueEmail`,
      endpoint_process_questionnaire: `${sfroute_base_url_rc}v3/processQuestionnaire`,
      endpoint_get_registration_configuration: `${sfroute_base_url_rc_public}v5/getRegistrationConfiguration&public=true`,
      endpoint_process_registration: `${sfroute_base_url_rc}v8/processRegistration`,
      endpoint_authenticate_participant_lead: `${sfroute_base_url_rc_public}v6/authenticateParticipantLead&public=true`,
      endpoint_get_screener_configuration: `${sfroute_base_url_rc}v2/getScreenerConfiguration`,
      endpoint_process_profile: `${sfroute_base_url_rc}v4/processProfile`,
      endpoint_process_welcome: `${sfroute_base_url_rc}v2/processWelcome`,
      endpoint_process_genetic: `${sfroute_base_url_rc}v2/processGenetic`,
      endpoint_getInspiratorTimes: `${sfroute_base_url_rc}v2/getInspiratorSessions`,
      endpoint_createEvent: `${sfroute_base_url_rc}v2/createEventPlId`,
      endpoint_updateStepCompleted: `${sfroute_base_url_rc}v2/updateStepCompleted`,
      endpoint_findSessions: `${sfroute_base_url_rc}v2/findInspiratorSessions`,
      endpoint_getEvents: `${sfroute_base_url_rc}v2/getEvents`,
      endpoint_getEvents_public: `${sfroute_base_url_rc_public}v1/getEvents&public=true`,
      endpoint_assignInspirator: `${sfroute_base_url_rc}v2/assignInspirator`,
      endpoint_getInspiratorInfo: `${sfroute_base_url_rc}v2/getInspirator`,
      endpoint_isJPMCPilot: `${sfroute_base_url_rc}v1/isJPMCPilot`,
      endpoint_getClientData: `${sfroute_base_url_rc_public}v4/getClientData&public=true`,
      endpoint_collectEmail: `${sfroute_base_url_rc}v1/collectEmail`,
    }
    break

  case "sfrc_ca":
    const ca_rc_base_public = "newtopiaca--rc.sandbox.my.salesforce-sites.com"
    const ca_rc_base = "newtopiaca--rc.my.salesforce.com"
    lambda_base = "https://release-api-sfroute.ntp-dev.com/"
    const ca_sfroute_base_url_rc_public = `${lambda_base}sfroute?url=${ca_rc_base_public}&path=${api_path}`
    const ca_sfroute_base_url_rc = `${lambda_base}sfroute?url=${ca_rc_base}&path=${api_path}${router}`
    country = "CA"
    liveAgentDeploymentScript = 'https://c.la1-c1-yul.salesforceliveagent.com/content/g/js/51.0/deployment.js'
    liveAgentPreChatScript = 'https://c.la1-c1-yul.salesforceliveagent.com/content/g/js/51.0/prechat.js'
    liveAgentInitURL = 'https://d.la1-c1-yul.salesforceliveagent.com/chat'
    liveAgentChatId = '5725o00000001Uw'
    liveAgentOrgId = '00D5o0000008an9'
    liveAgentButtonId = '5735o00000001V6'
    liveAgentImage = 'https://newtopiaca.secure.force.com/Dashboard/resource/1606966297000/liveAgent_chat'

    __CONFIG__ = {
      env,
      country,
      liveAgentDeploymentScript,
      liveAgentPreChatScript,
      liveAgentInitURL,
      liveAgentChatId,
      liveAgentOrgId,
      liveAgentButtonId,
      liveAgentImage,
      endpoint_get_liveagent: `${ca_sfroute_base_url_rc_public}v1/getLiveAgent&public=true`,
      endpoint_get_stepcompleted: `${ca_sfroute_base_url_rc}v3/getStepCompleted`,
      endpoint_get_landing_configuration: `${ca_sfroute_base_url_rc_public}v1/getLandingConfiguration&public=true`,
      endpoint_upsert_qna: `${ca_sfroute_base_url_rc}v3/upsertQnA`,
      endpoint_get_qna: `${ca_sfroute_base_url_rc}v3/getQnA`,
      endpoint_verify_unique_email: `${ca_sfroute_base_url_rc}v2/verifyUniqueEmail`,
      endpoint_process_questionnaire: `${ca_sfroute_base_url_rc}v3/processQuestionnaire`,
      endpoint_get_registration_configuration: `${ca_sfroute_base_url_rc_public}v5/getRegistrationConfiguration&public=true`,
      endpoint_process_registration: `${ca_sfroute_base_url_rc}v8/processRegistration`,
      endpoint_authenticate_participant_lead: `${ca_sfroute_base_url_rc_public}v6/authenticateParticipantLead&public=true`,
      endpoint_get_screener_configuration: `${ca_sfroute_base_url_rc}v2/getScreenerConfiguration`,
      endpoint_process_profile: `${ca_sfroute_base_url_rc}v4/processProfile`,
      endpoint_process_welcome: `${ca_sfroute_base_url_rc}v2/processWelcome`,
      endpoint_process_genetic: `${ca_sfroute_base_url_rc}v2/processGenetic`,
      endpoint_getInspiratorTimes: `${ca_sfroute_base_url_rc}v2/getInspiratorSessions`,
      endpoint_createEvent: `${ca_sfroute_base_url_rc}v2/createEventPlId`,
      endpoint_updateStepCompleted: `${ca_sfroute_base_url_rc}v2/updateStepCompleted`,
      endpoint_findSessions: `${ca_sfroute_base_url_rc}v2/findInspiratorSessions`,
      endpoint_getEvents: `${ca_sfroute_base_url_rc}v2/getEvents`,
      endpoint_getEvents_public: `${ca_sfroute_base_url_rc_public}v1/getEvents&public=true`,
      endpoint_assignInspirator: `${ca_sfroute_base_url_rc}v2/assignInspirator`,
      endpoint_getInspiratorInfo: `${ca_sfroute_base_url_rc}v2/getInspirator`,
      endpoint_isJPMCPilot: `${ca_sfroute_base_url_rc}v1/isJPMCPilot`,
      endpoint_getClientData: `${ca_sfroute_base_url_rc_public}v4/getClientData&public=true`,
      endpoint_collectEmail: `${ca_sfroute_base_url_rc}v1/collectEmail`,
    }
    break

  case 'stage':
    const stage_base_public = "newtopia--staging.sandbox.my.salesforce-sites.com"
    const stage_base = "newtopia--staging.my.salesforce.com"
    lambda_base = "https://sfroute.newtopia.com/"
    const sfroute_base_url_stage_public = `${lambda_base}sfroute?url=${stage_base_public}&path=${api_path}`
    const sfroute_base_url_stage = `${lambda_base}sfroute?url=${stage_base}&path=${api_path}${router}`

    __CONFIG__ = {
      env,
      country,
      liveAgentDeploymentScript,
      liveAgentPreChatScript,
      liveAgentInitURL,
      liveAgentChatId,
      liveAgentOrgId,
      liveAgentButtonId,
      liveAgentImage,
      endpoint_get_liveagent: `${sfroute_base_url_stage_public}v1/getLiveAgent&public=true`,
      endpoint_get_stepcompleted: `${sfroute_base_url_stage}v3/getStepCompleted`,
      endpoint_get_landing_configuration: `${sfroute_base_url_stage_public}v1/getLandingConfiguration&public=true`,
      endpoint_upsert_qna: `${sfroute_base_url_stage}v3/upsertQnA`,
      endpoint_get_qna: `${sfroute_base_url_stage}v3/getQnA`,
      endpoint_verify_unique_email: `${sfroute_base_url_stage}v2/verifyUniqueEmail`,
      endpoint_process_questionnaire: `${sfroute_base_url_stage}v3/processQuestionnaire`,
      endpoint_get_registration_configuration: `${sfroute_base_url_stage_public}v5/getRegistrationConfiguration&public=true`,
      endpoint_process_registration: `${sfroute_base_url_stage}v8/processRegistration`,
      endpoint_authenticate_participant_lead: `${sfroute_base_url_stage_public}v6/authenticateParticipantLead&public=true`,
      endpoint_get_screener_configuration: `${sfroute_base_url_stage}v2/getScreenerConfiguration`,
      endpoint_process_profile: `${sfroute_base_url_stage}v4/processProfile`,
      endpoint_process_welcome: `${sfroute_base_url_stage}v2/processWelcome`,
      endpoint_process_genetic: `${sfroute_base_url_stage}v2/processGenetic`,
      endpoint_getInspiratorTimes: `${sfroute_base_url_stage}v2/getInspiratorSessions`,
      endpoint_createEvent: `${sfroute_base_url_stage}v2/createEventPlId`,
      endpoint_updateStepCompleted: `${sfroute_base_url_stage}v2/updateStepCompleted`,
      endpoint_findSessions: `${sfroute_base_url_stage}v2/findInspiratorSessions`,
      endpoint_getEvents: `${sfroute_base_url_stage}v2/getEvents`,
      endpoint_getEvents_public: `${sfroute_base_url_stage_public}v1/getEvents&public=true`,
      endpoint_assignInspirator: `${sfroute_base_url_stage}v2/assignInspirator`,
      endpoint_getInspiratorInfo: `${sfroute_base_url_stage}v2/getInspirator`,
      endpoint_isJPMCPilot: `${sfroute_base_url_stage}v1/isJPMCPilot`,
      endpoint_getClientData: `${sfroute_base_url_stage_public}v4/getClientData&public=true`,
      endpoint_collectEmail: `${sfroute_base_url_stage}v1/collectEmail`,
    }
    break

  
  case 'stage_ca':
    const ca_stage_base_public = "newtopiaca--staging.sandbox.my.salesforce-sites.com"
    const ca_stage_base = "newtopiaca--staging.my.salesforce.com"
    lambda_base = "https://sfroute.newtopia.com/"
    const ca_sfroute_base_url_stage_public = `${lambda_base}sfroute?url=${ca_stage_base_public}&path=${api_path}`
    const ca_sfroute_base_url_stage = `${lambda_base}sfroute?url=${ca_stage_base}&path=${api_path}${router}`
    country = "CA"
    liveAgentDeploymentScript = 'https://c.la1-c1-yul.salesforceliveagent.com/content/g/js/51.0/deployment.js'
    liveAgentPreChatScript = 'https://c.la1-c1-yul.salesforceliveagent.com/content/g/js/51.0/prechat.js'
    liveAgentInitURL = 'https://d.la1-c1-yul.salesforceliveagent.com/chat'
    liveAgentChatId = '5725o00000001Uw'
    liveAgentOrgId = '00D5o0000008an9'
    liveAgentButtonId = '5735o00000001V6'
    liveAgentImage = 'https://newtopiaca.secure.force.com/Dashboard/resource/1606966297000/liveAgent_chat'

    
    __CONFIG__ = {
      env,
      country,
      liveAgentDeploymentScript,
      liveAgentPreChatScript,
      liveAgentInitURL,
      liveAgentChatId,
      liveAgentOrgId,
      liveAgentButtonId,
      liveAgentImage,
      endpoint_get_liveagent: `${ca_sfroute_base_url_stage_public}v1/getLiveAgent&public=true`,
      endpoint_get_stepcompleted: `${ca_sfroute_base_url_stage}v3/getStepCompleted`,
      endpoint_get_landing_configuration: `${ca_sfroute_base_url_stage_public}v1/getLandingConfiguration&public=true`,
      endpoint_upsert_qna: `${ca_sfroute_base_url_stage}v3/upsertQnA`,
      endpoint_get_qna: `${ca_sfroute_base_url_stage}v3/getQnA`,
      endpoint_verify_unique_email: `${ca_sfroute_base_url_stage}v2/verifyUniqueEmail`,
      endpoint_process_questionnaire: `${ca_sfroute_base_url_stage}v3/processQuestionnaire`,
      endpoint_get_registration_configuration: `${ca_sfroute_base_url_stage_public}v5/getRegistrationConfiguration&public=true`,
      endpoint_process_registration: `${ca_sfroute_base_url_stage}v8/processRegistration`,
      endpoint_authenticate_participant_lead: `${ca_sfroute_base_url_stage_public}v6/authenticateParticipantLead&public=true`,
      endpoint_get_screener_configuration: `${ca_sfroute_base_url_stage}v2/getScreenerConfiguration`,
      endpoint_process_profile: `${ca_sfroute_base_url_stage}v4/processProfile`,
      endpoint_process_welcome: `${ca_sfroute_base_url_stage}v2/processWelcome`,
      endpoint_process_genetic: `${ca_sfroute_base_url_stage}v2/processGenetic`,
      endpoint_getInspiratorTimes: `${ca_sfroute_base_url_stage}v2/getInspiratorSessions`,
      endpoint_createEvent: `${ca_sfroute_base_url_stage}v2/createEventPlId`,
      endpoint_updateStepCompleted: `${ca_sfroute_base_url_stage}v2/updateStepCompleted`,
      endpoint_findSessions: `${ca_sfroute_base_url_stage}v2/findInspiratorSessions`,
      endpoint_getEvents: `${ca_sfroute_base_url_stage}v2/getEvents`,
      endpoint_getEvents_public: `${ca_sfroute_base_url_stage_public}v1/getEvents&public=true`,
      endpoint_assignInspirator: `${ca_sfroute_base_url_stage}v2/assignInspirator`,
      endpoint_getInspiratorInfo: `${ca_sfroute_base_url_stage}v2/getInspirator`,
      endpoint_isJPMCPilot: `${ca_sfroute_base_url_stage}v1/isJPMCPilot`,
      endpoint_getClientData: `${ca_sfroute_base_url_stage_public}v4/getClientData&public=true`,
      endpoint_collectEmail: `${ca_sfroute_base_url_stage}v1/collectEmail`,
    }
    break
    
  case 'master':
    const prod_base_public = "newtopia.secure.force.com"
    const prod_base = "newtopia.my.salesforce.com"
    lambda_base = "https://prod-api-sfroute.newtopia.com/"
    const sfroute_base_url_prod_public = `${lambda_base}sfroute?url=${prod_base_public}&path=${api_path}`
    const sfroute_base_url_prod = `${lambda_base}sfroute?url=${prod_base}&path=${api_path}${router}`
    __CONFIG__ = {
      env,
      country,
      liveAgentDeploymentScript,
      liveAgentPreChatScript,
      liveAgentInitURL,
      liveAgentChatId,
      liveAgentOrgId,
      liveAgentButtonId,
      liveAgentImage,
      endpoint_get_liveagent: `${sfroute_base_url_prod_public}v1/getLiveAgent&public=true`,
      endpoint_get_stepcompleted: `${sfroute_base_url_prod}v3/getStepCompleted`,
      endpoint_get_landing_configuration: `${sfroute_base_url_prod_public}v1/getLandingConfiguration&public=true`,
      endpoint_upsert_qna: `${sfroute_base_url_prod}v3/upsertQnA`,
      endpoint_get_qna: `${sfroute_base_url_prod}v3/getQnA`,
      endpoint_process_questionnaire: `${sfroute_base_url_prod}v3/processQuestionnaire`,
      endpoint_verify_unique_email: `${sfroute_base_url_prod}v2/verifyUniqueEmail`,
      endpoint_get_registration_configuration: `${sfroute_base_url_prod_public}v5/getRegistrationConfiguration&public=true`,
      endpoint_process_registration: `${sfroute_base_url_prod}v8/processRegistration`,
      endpoint_authenticate_participant_lead: `${sfroute_base_url_prod_public}v6/authenticateParticipantLead&public=true`,
      endpoint_get_screener_configuration: `${sfroute_base_url_prod}v2/getScreenerConfiguration`,
      endpoint_process_profile: `${sfroute_base_url_prod}v4/processProfile`,
      endpoint_process_welcome: `${sfroute_base_url_prod}v2/processWelcome`,
      endpoint_process_genetic: `${sfroute_base_url_prod}v2/processGenetic`,
      endpoint_getInspiratorTimes: `${sfroute_base_url_prod}v2/getInspiratorSessions`,
      endpoint_createEvent: `${sfroute_base_url_prod}v2/createEventPlId`,
      endpoint_updateStepCompleted: `${sfroute_base_url_prod}v2/updateStepCompleted`,
      endpoint_findSessions: `${sfroute_base_url_prod}v2/findInspiratorSessions`,
      endpoint_getEvents: `${sfroute_base_url_prod}v2/getEvents`,
      endpoint_getEvents_public: `${sfroute_base_url_prod_public}v1/getEvents&public=true`,
      endpoint_assignInspirator: `${sfroute_base_url_prod}v2/assignInspirator`,
      endpoint_getInspiratorInfo: `${sfroute_base_url_prod}v2/getInspirator`,
      endpoint_isJPMCPilot: `${sfroute_base_url_prod}v1/isJPMCPilot`,
      endpoint_getClientData: `${sfroute_base_url_prod_public}v4/getClientData&public=true`,
      endpoint_collectEmail: `${sfroute_base_url_prod}v1/collectEmail`,
    }
    break
  case 'master_ca':
    const ca_prod_base_public = "newtopiaca.secure.force.com"
    const ca_prod_base = "newtopiaca.my.salesforce.com"
    lambda_base = "https://prod-api-sfroute.newtopia.com/"
    const ca_sfroute_base_url_prod_public = `${lambda_base}sfroute?url=${ca_prod_base_public}&path=${api_path}`
    const ca_sfroute_base_url_prod = `${lambda_base}sfroute?url=${ca_prod_base}&path=${api_path}${router}`
    country = "CA"
    liveAgentDeploymentScript = 'https://c.la1-c1-yul.salesforceliveagent.com/content/g/js/51.0/deployment.js'
    liveAgentPreChatScript = 'https://c.la1-c1-yul.salesforceliveagent.com/content/g/js/51.0/prechat.js'
    liveAgentInitURL = 'https://d.la1-c1-yul.salesforceliveagent.com/chat'
    liveAgentChatId = '5725o00000001Uw'
    liveAgentOrgId = '00D5o0000008an9'
    liveAgentButtonId = '5735o00000001V6'
    liveAgentImage = 'https://newtopiaca.secure.force.com/Dashboard/resource/1606966297000/liveAgent_chat'

    
    __CONFIG__ = {
      env,
      country,
      liveAgentDeploymentScript,
      liveAgentPreChatScript,
      liveAgentInitURL,
      liveAgentChatId,
      liveAgentOrgId,
      liveAgentButtonId,
      liveAgentImage,
      endpoint_get_liveagent: `${ca_sfroute_base_url_prod_public}v1/getLiveAgent&public=true`,
      endpoint_get_stepcompleted: `${ca_sfroute_base_url_prod}v3/getStepCompleted`,
      endpoint_get_landing_configuration: `${ca_sfroute_base_url_prod_public}v1/getLandingConfiguration&public=true`,
      endpoint_upsert_qna: `${ca_sfroute_base_url_prod}v3/upsertQnA`,
      endpoint_get_qna: `${ca_sfroute_base_url_prod}v3/getQnA`,
      endpoint_process_questionnaire: `${ca_sfroute_base_url_prod}v3/processQuestionnaire`,
      endpoint_verify_unique_email: `${ca_sfroute_base_url_prod}v2/verifyUniqueEmail`,
      endpoint_get_registration_configuration: `${ca_sfroute_base_url_prod_public}v5/getRegistrationConfiguration&public=true`,
      endpoint_process_registration: `${ca_sfroute_base_url_prod}v8/processRegistration`,
      endpoint_authenticate_participant_lead: `${ca_sfroute_base_url_prod_public}v6/authenticateParticipantLead&public=true`,
      endpoint_get_screener_configuration: `${ca_sfroute_base_url_prod}v2/getScreenerConfiguration`,
      endpoint_process_profile: `${ca_sfroute_base_url_prod}v4/processProfile`,
      endpoint_process_welcome: `${ca_sfroute_base_url_prod}v2/processWelcome`,
      endpoint_process_genetic: `${ca_sfroute_base_url_prod}v2/processGenetic`,
      endpoint_getInspiratorTimes: `${ca_sfroute_base_url_prod}v2/getInspiratorSessions`,
      endpoint_createEvent: `${ca_sfroute_base_url_prod}v2/createEventPlId`,
      endpoint_updateStepCompleted: `${ca_sfroute_base_url_prod}v2/updateStepCompleted`,
      endpoint_findSessions: `${ca_sfroute_base_url_prod}v2/findInspiratorSessions`,
      endpoint_getEvents: `${ca_sfroute_base_url_prod}v2/getEvents`,
      endpoint_getEvents_public: `${ca_sfroute_base_url_prod_public}v1/getEvents&public=true`,
      endpoint_assignInspirator: `${ca_sfroute_base_url_prod}v2/assignInspirator`,
      endpoint_getInspiratorInfo: `${ca_sfroute_base_url_prod}v2/getInspirator`,
      endpoint_isJPMCPilot: `${ca_sfroute_base_url_prod}v1/isJPMCPilot`,
      endpoint_getClientData: `${ca_sfroute_base_url_prod_public}v4/getClientData&public=true`,
      endpoint_collectEmail: `${ca_sfroute_base_url_prod}v1/collectEmail`,
    }
    break
}
export default __CONFIG__

